window.HMAPJobApprovalFlowSettingsForm = function ($scope, brand, $q, userServices, userPermissions, jobApprovalDataService, hmapService, brandServices) {
    var self = this;

    self.brandId = brand.id;
    self.isHrActionsServiceEnabled = false;
    self.isJobApprovalFlowServiceEnabled = false;
    self.tabs = jobApprovalDataService.SERVICES_NEED_APPROVALS;
    var shownTabs = [];

    var init = function () {
        var promises = {
            isJobApprovalFlowServiceEnabled: userServices.isServiceEnabled(userServices.SERVICES.JOB_APPROVAL_FLOW, self.brandId),
            isHrActionsServiceEnabled: userServices.isServiceEnabled(userServices.SERVICES.HR_ACTIONS, self.brandId),
            isApprovalFlowServiceEnabled: userServices.isServiceEnabled(userServices.SERVICES.APPROVAL_FLOW, self.brandId),
            policyParser: userPermissions.getBrandPolicy(self.brandId),
            getBrandApprovalFlowSettings: jobApprovalDataService.getBrandApprovalFlowSettings(self.brandId),
            isHighestParent: hmapService.isHighestParent(self.brandId)
        };

        $q.all(promises)
            .then(async(data) => {
                self.isJobApprovalFlowServiceEnabled = data['isJobApprovalFlowServiceEnabled'];
                self.isHrActionsServiceEnabled = data['isHrActionsServiceEnabled'];
                self.isApprovalFlowServiceEnabled = data['isApprovalFlowServiceEnabled'];
                var policyParser = data['policyParser'];
                var brandApprovalFlowsSettings = data['getBrandApprovalFlowSettings'] && data['getBrandApprovalFlowSettings'].settings;
                self.canViewHrActions = policyParser.has(userPermissions.PERMISSIONS.VIEW_HR_ACTIONS);
                self.showJobApprovalTab = self.isJobApprovalFlowServiceEnabled && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);
                self.showHrActionsApprovalTab = self.isHrActionsServiceEnabled && self.canViewHrActions && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);
                self.showWageJobTitleTab = brandApprovalFlowsSettings['teamlive_position_enabled'] && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);
                self.showEmployeeTransfareShare = brandApprovalFlowsSettings['teamlive_location_period_enabled'] && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);
                self.showForecastApprovalTab = brandApprovalFlowsSettings['labor_forecast_enabled'] && policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);

                self.isOfferApprovalFlowSettingsEnabled = brandApprovalFlowsSettings?.offer_letter_enabled;
                self.isDocumentsApprovalFlowSettingsEnabled = brandApprovalFlowsSettings?.documents_enabled;
                self.isShowOfferApprovalFlow = self.isApprovalFlowServiceEnabled && self.isOfferApprovalFlowSettingsEnabled;
                self.isShowDocumentsApprovalFlow = self.isApprovalFlowServiceEnabled && self.isDocumentsApprovalFlowSettingsEnabled;

                let isHighestParent = data.isHighestParent;

                if (isHighestParent) {
                    let promises = [
                        brandServices.check(brandServices.SERVICES.PERFORMANCE_REVIEW, self.brandId, true),
                        PmsAPI.getBusinessBrandSettings(self.brandId)
                    ];

                    let [
                        hasPMSService,
                        SecondApprovalSettings
                    ] = await Promise.all(promises);
                    self.hasPMSService = !!hasPMSService;
                    self.secondApprovalSettings = SecondApprovalSettings;
                    self.isSecondApprovalReviewsEnabled = SecondApprovalSettings?.enable_reviews_second_approval;
                    self.hasSecondApprovalsPermission = policyParser.has(userPermissions.PERMISSIONS.MANAGE_APPROVAL_FLOWS_SETTINGS);
                }



                if (self.showJobApprovalTab) {
                    shownTabs.push('JOB_APPROVAL_FLOW');
                }
                if (self.isShowOfferApprovalFlow) {
                    shownTabs.push('OFFER_LETTER');
                }
                if (self.isShowDocumentsApprovalFlow) {
                    shownTabs.push('DOCUMENTS');
                }
                if (self.showHrActionsApprovalTab) {
                    shownTabs.push('HR_ACTIONS');
                }
                if (self.showWageJobTitleTab) {
                    shownTabs.push('TEAMLIVE_POSITION');
                }
                if (self.showEmployeeTransfareShare) {
                    shownTabs.push('TEAMLIVE_LOCATION_PERIOD');
                }
                if (self.showForecastApprovalTab) {
                    shownTabs.push('LABOR_FORECAST')
                }
                if (self.isPerformanceSecondApprovalShown()) {
                    shownTabs.push(self.tabs.PERFORMANCE_SECOND_APPROVAL.code);
                }
                self.selectedTabItem = self.tabs[shownTabs[0]].code;
                jobApprovalDataService.setActiveService(self.selectedTabItem);
            });
        
    };

    self.setActiveTab = function(activeTab) {
        self.selectedTabItem = activeTab;
        if (self.selectedTabItem !== self.tabs.PERFORMANCE_SECOND_APPROVAL.code) {
            jobApprovalDataService.setActiveService(activeTab);
        }
    };

    self.isPerformanceSecondApprovalShown = () => {
        return (
            self.hasPMSService &&
            self.isSecondApprovalReviewsEnabled &&
            self.hasSecondApprovalsPermission
        );
    };

    self.showApprovalListingComponent = () => {
        return (
            self.selectedTabItem &&
            self.selectedTabItem !== self.tabs.PERFORMANCE_SECOND_APPROVAL.code
        );
    };

    init();
};
